import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, OnDestroy, AfterViewInit, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { Popover } from 'primeng/popover';
import { BlockScheduleModel, BlockScheduleViewModel, BlockScheduleStatus, ShippingStatus, InverterIgbtType } from '../../models/blockschedule.model';
import { ProjectService } from '../../services/project.service';
import { MessageService, MenuItem } from 'primeng/api';
import { Toast } from "primeng/toast";
import { ProjectStateService } from '../../services/project-state.service';
import { ProjectModel } from '../../models/project.model';
import { Blockschedulebulkupdate } from '../blockschedulebulkupdate/blockschedulebulkupdate';
import { SkidtemplateconfigComponent } from '../skidtemplateconfig/skidtemplateconfig';
import { ChangeshipdateComponent } from '../changeshipdate/changeshipdate';
import { SkidspecComponent } from '../skidspec/skidspec';
import { Table, TableModule } from "primeng/table";
import { ActivatedRoute } from '@angular/router';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil, map, filter, take, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { UserService } from '../../services/user.service';
import { PermissionHelperService } from '../../services/permission-helper.service';
import { PAGE_KEYS, PERMISSION_KEYS } from '../../constants/permission.constants';
import { PermissionService } from '../../core/services/permission.service';
import { buildProjectDownloadFileName } from '../../utils/download-file-name.utils';

@Component({
  selector: 'app-blockschedule',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    InputNumberModule,
    DatePickerModule,
    SelectModule,
    FieldsetModule,
    CheckboxModule,
    Toast,
    TableModule,
    MenuModule,
    Popover
  ],
  templateUrl: './blockschedule.html',
  styleUrl: './blockschedule.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockscheduleComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private resize$ = new Subject<void>();
  private originalBlockScheduleRows = new Map<number, any>();
  blockScheduleForm!: FormGroup;
  blockScheduleData: BlockScheduleModel | null = null;
  projectId: number = 0;
  projectInfo: ProjectModel = {} as ProjectModel;
  igbtOptions = [
    { label: 'Mitsubishi', value: InverterIgbtType.MITSUBISHI },
    { label: 'Infineon', value: InverterIgbtType.INFINEON }
  ];
  checkOptions = ['Yes', 'No'];
  skidConfigOptions = [
    { label: 'N1', value: 'N1' },
    { label: 'N2', value: 'N2' },
    { label: 'N3', value: 'N3' },
    { label: 'N4', value: 'N4' },
    { label: 'N5', value: 'N5' },
    { label: 'N6', value: 'N6' },
    { label: 'N7', value: 'N7' }
  ];
  shippingStatusOptions = [
    { label: '', value: null },
    { label: 'In Transit', value: ShippingStatus.IN_TRANSIT },
    { label: 'Delivered', value: ShippingStatus.DELIVERED },
    { label: 'Delayed', value: ShippingStatus.DELAYED },
    { label: 'Returned', value: ShippingStatus.RETURNED }
  ];
  installedOptions = [
    { label: '', value: null },
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ];
  wildlifeDeterrentOptions = [
    { label: '', value: null },
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
  ];
  dialogRef: DynamicDialogRef | null = null;
  activeShipBlock: BlockScheduleViewModel | null = null;
  activeArrivalBlock: BlockScheduleViewModel | null = null;
  private shipTransitDays: number = 0;
  activeDeliveryBlock: BlockScheduleViewModel | null = null;
  activeEstimatedDeliveryBlock: BlockScheduleViewModel | null = null;
  @ViewChild('dt') dt!: Table;
  blockScheduleList: BlockScheduleViewModel[] = [];
  filteredBlockScheduleList: BlockScheduleViewModel[] = [];
  selectedRows: BlockScheduleViewModel[] = [];
  selectAll: boolean = false;
  skidStatusOptions = [
    { label: '', value: null },
    { label: 'In-Progress', value: BlockScheduleStatus.IN_PROGRESS },
    { label: 'Complete', value: BlockScheduleStatus.COMPLETE },
    { label: 'Shipped', value: BlockScheduleStatus.SHIPPED }
  ];
  saving: boolean = false;
  isReadOnly: boolean = false;
  canView: boolean = false;
  canTemplateConfig: boolean = false;
  canSkidSpec: boolean = false;
  canChangeShipDate: boolean = false;
  canExport: boolean = false;
  canBulkUpdate: boolean = false;
  canSave: boolean = false;
  canSendEmail: boolean = false;
  newSkidConfig: string = '';
  tableScrollHeight: string = '600px'; // Dynamic table height
  private isProjectInactive = false;
  private resizeObserver: ResizeObserver | null = null;
  actionsMenu: MenuItem[] = [];

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private projectService: ProjectService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private projectStateService: ProjectStateService,
    private messageService: MessageService,
    private permissionHelper: PermissionHelperService,
    public permissions: PermissionService,
    private el: ElementRef
  ) {

  }

  ngOnInit(): void {
    console.log('Blockschedule dialog data:', this.config.data);

    // Setup debounced resize handler to avoid excessive calculations
    this.resize$.pipe(
      debounceTime(150), // Wait 150ms after last resize event
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.calculateTableHeight();
    });

    // 1. Project info subscription (with cleanup)
    this.projectStateService.currentProject$
      .pipe(
        distinctUntilChanged((prev, curr) => prev?.projectId === curr?.projectId),
        takeUntil(this.destroy$)
      )
      .subscribe(project => {
        if (project && project.projectId) {
          this.projectInfo = project;
          console.log('Project Layout - Project from state service:', project);
        }
      });

    // 2. Project active status subscription (with cleanup)
    this.projectStateService.currentProjectUserActive$
      .pipe(
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe(isActive => {
        this.isProjectInactive = isActive === false;
        this.updateReadOnlyState();
      });

    // 3. BUTTONS: Load permissions immediately for action buttons (one-time)
    this.projectStateService.currentProjectPermissions$
      .pipe(take(1))
      .subscribe(() => {
        this.setPermissions();
        this.initializeActionsMenu();
        this.cdr.markForCheck();
      });

    // 4. GRID: Use combineLatest to load data only when BOTH projectId AND canView are ready
    combineLatest([
      this.route.paramMap.pipe(
        map(params => parseInt(params.get('projectId') || '0')),
        filter(id => id > 0)
      ),
      this.projectStateService.currentProjectPermissions$.pipe(
        map(() => this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.VIEW)),
        filter(canView => canView === true)
      )
    ]).pipe(
      take(1),  // Load only once
      takeUntil(this.destroy$)
    ).subscribe(([projectId]) => {
      this.projectId = projectId;
      console.log('Project ID from URL:', this.projectId);

      // Load user's project role and then load block schedule
      this.loadProjectRoleAndData();
    });

    // 5. Search subscription — filters grid display only
    this.projectStateService.pageSearch$.pipe(takeUntil(this.destroy$)).subscribe(search => {
      this.applySearch(search);
    });

  }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(() => this.resize$.next());
    this.resizeObserver.observe(this.el.nativeElement);
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    // Trigger debounced calculation (prevents excessive calls)
    this.resize$.next();
  }

  // Helper method to set all permissions
  private setPermissions(): void {
    this.canView = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.VIEW);
    this.canTemplateConfig = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.TEMPLATE_CONFIG);
    this.canSkidSpec = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.SKID_SPEC);
    this.canChangeShipDate = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.CHANGE_SHIP_DATE);
    this.canExport = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.EXPORT);
    this.canBulkUpdate = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.BULK_UPDATE);
    this.canSave = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.SAVE);
    this.canSendEmail = this.permissionHelper.has(PAGE_KEYS.BLOCK_SCHEDULE, PERMISSION_KEYS.SEND_EMAIL);
    this.updateReadOnlyState();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.resizeObserver?.disconnect();
  }

  private calculateTableHeight(): void {
    try {
      const hostEl = this.el.nativeElement as HTMLElement;
      const hostHeight = hostEl.clientHeight;
      const header = hostEl.querySelector('.bs-header') as HTMLElement;
      const headerHeight = header?.offsetHeight || 48;

      // Subtract header height + bottom padding from available host height
      const bottomPadding = 16;
      const availableHeight = hostHeight - headerHeight - bottomPadding;
      const finalHeight = Math.max(availableHeight, 400);

      const newHeight = `${finalHeight}px`;
      if (this.tableScrollHeight !== newHeight) {
        this.tableScrollHeight = newHeight;
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error calculating table height:', error);
      if (this.tableScrollHeight !== '600px') {
        this.tableScrollHeight = '600px';
        this.cdr.detectChanges();
      }
    }
  }

  private applySearch(search: string): void {
    const term = (search || '').trim().toLowerCase();
    if (!term) {
      this.filteredBlockScheduleList = [...this.blockScheduleList];
    } else {
      const fmt = (d: Date | null | undefined): string =>
        d ? `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}` : '';
      this.filteredBlockScheduleList = this.blockScheduleList.filter(b =>
        (b.tmeicSkidNo != null ? String(b.tmeicSkidNo) : '').includes(term) ||
        (b.integratorSkidSerialNo || '').toLowerCase().includes(term) ||
        this.getCustomerMvpsDisplay(b).toLowerCase().includes(term) ||
        (b.skidConfiguration || '').toLowerCase().includes(term) ||
        (b.billoflading || '').toLowerCase().includes(term) ||
        (b.shippingStatus || '').toLowerCase().includes(term) ||
        (b.skidStatus || '').toLowerCase().includes(term) ||
        (b.logisticsComment || '').toLowerCase().includes(term) ||
        (b.notes || '').toLowerCase().includes(term) ||
        (b.mvXfmrDesign || '').toLowerCase().includes(term) ||
        (b.mvXfmrSerialNo || '').toLowerCase().includes(term) ||
        (b.lvXfmrSerialNo || '').toLowerCase().includes(term) ||
        (b.scadaSerialNo || '').toLowerCase().includes(term) ||
        (b.trackerSerialNo1 || '').toLowerCase().includes(term) ||
        (b.scu || '').toLowerCase().includes(term) ||
        (b.dis || '').toLowerCase().includes(term) ||
        (b.epanb || '').toLowerCase().includes(term) ||
        (b.dcFuses || '').toLowerCase().includes(term) ||
        (b.wildlifeRepellentAdded || '').toLowerCase().includes(term) ||
        (b.wildlifeWarningLabelApplied || '').toLowerCase().includes(term) ||
        (b.inv1SerialNo || '').toLowerCase().includes(term) ||
        (b.inv2SerialNo || '').toLowerCase().includes(term) ||
        (b.inv3SerialNo || '').toLowerCase().includes(term) ||
        (b.inv4SerialNo || '').toLowerCase().includes(term) ||
        (b.inv5SerialNo || '').toLowerCase().includes(term) ||
        (b.inv6SerialNo || '').toLowerCase().includes(term) ||
        (b.inv7SerialNo || '').toLowerCase().includes(term) ||
        (b.inv1Igbt || '').toLowerCase().includes(term) ||
        (b.inv2Igbt || '').toLowerCase().includes(term) ||
        (b.inv3Igbt || '').toLowerCase().includes(term) ||
        (b.inv4Igbt || '').toLowerCase().includes(term) ||
        (b.inv5Igbt || '').toLowerCase().includes(term) ||
        (b.inv6Igbt || '').toLowerCase().includes(term) ||
        (b.inv7Igbt || '').toLowerCase().includes(term) ||
        (b.bushingSize != null ? String(b.bushingSize) : '').includes(term) ||
        (b.overWeight ? 'yes' : 'no').includes(term) ||
        (b.overDimension ? 'yes' : 'no').includes(term) ||
        fmt(b.shipDate).includes(term) ||
        fmt(b.arrivalDate).includes(term) ||
        fmt(b.deliveryDate).includes(term) ||
        fmt(b.estimatedDeliveryDate).includes(term) ||
        fmt(b.appointmentTime).includes(term)
      );
    }
    this.cdr.markForCheck();
    setTimeout(() => {
      this.dt?.scroller?.scrollTo({ top: 0 });
      this.cdr.markForCheck();
    }, 0);
  }

  private updateReadOnlyState(): void {
    this.isReadOnly = this.isProjectInactive || !this.canSave;
    this.cdr.markForCheck();
  }

  /**
   * Match Equipment-page title behavior: a saved customer value takes
   * precedence; otherwise generate the user-facing MVPS fallback.
   */
  getCustomerMvpsDisplay(block: BlockScheduleViewModel): string {
    const savedValue = (block.customerSkidNumber || '').trim();
    if (savedValue) {
      return savedValue;
    }

    return `${this.getBlockScheduleDisplayPrefix()} #${block.tmeicSkidNo ?? ''}`.trim();
  }

  private getBlockScheduleDisplayPrefix(): string {
    const configuredPrefix = (this.projectInfo?.prefix || '').trim();
    return !configuredPrefix || configuredPrefix.toLowerCase() === 'skid'
      ? 'MVPS'
      : configuredPrefix;
  }

  onCustomerMvpsChange(block: BlockScheduleViewModel, value: string): void {
    // Persist only an explicit user edit; rendering must remain non-mutating.
    block.customerSkidNumber = value;
  }

  private initializeActionsMenu(): void {
    this.actionsMenu = [];

    // Figma order: Bulk Upload → Export → Template Config → (others)
    if (this.canBulkUpdate) {
      this.actionsMenu.push({
        label: 'Bulk Upload',
        icon: 'ri-upload-2-line',
        command: () => this.openBulkUpdateDialog(),
        disabled: this.isReadOnly
      });
    }

    if (this.canExport) {
      this.actionsMenu.push({
        label: 'Export',
        icon: 'ri-send-plane-line',
        command: () => this.exportBlockSchedule()
      });
    }

    if (this.canTemplateConfig) {
      this.actionsMenu.push({
        label: 'Template Config',
        icon: 'ri-folder-settings-line',
        command: () => this.openTemplateConfig(),
        disabled: this.isReadOnly
      });
    }

    if (this.canSkidSpec) {
      this.actionsMenu.push({
        label: 'MV Power Station Spec',
        icon: 'ri-file-list-3-line',
        command: () => this.openSkidSpec()
      });
    }

    if (this.canChangeShipDate) {
      this.actionsMenu.push({
        label: 'Change Ship Date',
        icon: 'ri-calendar-line',
        command: () => this.openChangeShipDateDialog(),
        disabled: this.isReadOnly || this.selectedRows.length === 0
      });
    }

    if (this.canSendEmail) {
      this.actionsMenu.push({
        label: 'Send Email',
        icon: 'ri-mail-line',
        command: () => this.sendEmail()
      });
    }

  }

  /**
   * Load user's project role first, then load block schedule data
   * This ensures permissions are set before rendering the grid
   */
  private loadProjectRoleAndData(): void {
    if (!this.projectId || this.projectId <= 0) {
      console.error('Invalid project ID:', this.projectId);
      return;
    }

    // First, get user's project role
    this.projectService.getUserProjectPermissions(this.projectId).subscribe({
      next: (permissionData) => {
        console.log('User Project Permissions:', permissionData);
        console.log('Role ID from API:', permissionData.roleId);
        console.log('Role Name from API:', permissionData.roleName);
        // Set the project role in PermissionService
        this.permissions.setProjectRole(permissionData.roleId);
        console.log('Project Role set in PermissionService:', this.permissions.currentProjectRole);
        console.log('isReadOnly:', this.isReadOnly);
        console.log('canSave:', this.canSave);
        console.log('isIntegrator:', this.permissions.isIntegrator);
        console.log('isCustomer:', this.permissions.isCustomer);
        console.log('hasFullAccess:', this.permissions.hasFullAccess);
        // Now load the block schedule data
        this.loadBlockScheduleData();
      },
      error: (error) => {
        console.error('Error loading project permissions:', error);
        // Still try to load data even if permissions fail
        this.loadBlockScheduleData();
      }
    });
  }

  /**
   * Load block schedule data from API
   */
  private loadBlockScheduleData(): void {
    this.projectService.getProjectBlockSchedule(this.projectId, false).subscribe({
      next: (data) => {
        console.log('Block Schedule Data:', data);
        // Ensure data is an array before assigning
        const scheduleList = Array.isArray(data) ? data : [];
        this.captureOriginalBlockScheduleRows(scheduleList);

        // Convert date strings to Date objects and pre-compute display properties
        scheduleList.forEach(x => {
          x.shipDate = x.shipDate != null ? new Date(x.shipDate) : null;
          x.arrivalDate = x.arrivalDate != null ? new Date(x.arrivalDate) : null;
          x.deliveryDate = x.deliveryDate != null ? new Date(x.deliveryDate) : null;
          x.estimatedDeliveryDate = x.estimatedDeliveryDate != null ? new Date(x.estimatedDeliveryDate) : null;
          x.appointmentTime = x.appointmentTime != null ? new Date(x.appointmentTime) : null;

          // Pre-compute all display properties to avoid function calls in template
          this.computeRowProperties(x);
        });

        this.blockScheduleList = scheduleList;
        this.applySearch(this.projectStateService.getPageSearch());

        // Calculate skid config once when data loads
        this.newSkidConfig = this.calculateSkidConfig();

        // Single markForCheck after all updates are complete
        this.cdr.markForCheck();

        // Recalculate height after data loads (header might change size)
        setTimeout(() => this.calculateTableHeight(), 0);
      },
      error: (error) => {
        console.error('Error loading project block schedule:', error);
        this.blockScheduleList = [];
        this.filteredBlockScheduleList = [];
        this.cdr.markForCheck();
      }
    });
  }

  /**
   * Load block schedule (used for refresh after save operations)
   * Permissions are already loaded, just reload the data
   */
  private loadBlockSchedule(): void {
    if (!this.projectId || this.projectId <= 0) {
      console.error('Invalid project ID:', this.projectId);
      return;
    }

    this.loadBlockScheduleData();
  }

  // Pre-compute all display properties for a block to avoid function calls in template
  private computeRowProperties(block: BlockScheduleViewModel): void {
    // Compute row completed status
    block._actualSkidStatus = this.normalizeSkidStatusValue(block.skidStatus);
    block._isCompleted = this.isCompletedLikeStatus(block.skidStatus);

    // Compute inverter enabled states based on skid configuration
    const configNum = block.skidConfiguration ? parseInt(block.skidConfiguration.substring(1)) : 0;
    block._inv1Enabled = configNum >= 1;
    block._inv2Enabled = configNum >= 2;
    block._inv3Enabled = configNum >= 3;
    block._inv4Enabled = configNum >= 4;
    block._inv5Enabled = configNum >= 5;
    block._inv6Enabled = configNum >= 6;
    block._inv7Enabled = configNum >= 7;

    // Compute weekend flags for dates
    block._isShipWeekend = this.checkIsWeekend(block.shipDate);
    block._isArrivalWeekend = this.checkIsWeekend(block.arrivalDate);
  }

  // Helper to check if date is weekend (used internally, not in template)
  private checkIsWeekend(date: Date | null | undefined): boolean {
    if (!date) return false;
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  private isCompletedLikeStatus(status?: string | null): boolean {
    const normalized = (status || '').trim().toLowerCase();
    return normalized === BlockScheduleStatus.COMPLETE.toLowerCase() ||
           normalized === 'completed' ||
           normalized === BlockScheduleStatus.SHIPPED.toLowerCase();
  }

  private normalizeSkidStatusValue(status?: string | null): string | null {
    const trimmed = (status ?? '').trim();
    return trimmed.length > 0 ? trimmed : null;
  }

  private getRequiredInverterCount(skidConfiguration?: string | null): number {
    if (!skidConfiguration) {
      return 0;
    }

    // Accept formats like N4, n4, 4, or labels containing a number.
    const match = skidConfiguration.trim().toUpperCase().match(/(\d+)/);
    if (!match) {
      return 0;
    }

    const count = Number(match[1]);
    if (Number.isNaN(count) || count < 0) {
      return 0;
    }

    return Math.min(count, 7);
  }

  private getMissingInverterSerials(block: BlockScheduleViewModel, requiredCount: number): number[] {
    const serials = [
      block.inv1SerialNo,
      block.inv2SerialNo,
      block.inv3SerialNo,
      block.inv4SerialNo,
      block.inv5SerialNo,
      block.inv6SerialNo,
      block.inv7SerialNo
    ];

    const missing: number[] = [];
    for (let i = 0; i < requiredCount; i++) {
      const value = serials[i];
      if (!value || !value.trim()) {
        missing.push(i + 1);
      }
    }

    return missing;
  }

  onSubmit(): void {
    if (this.blockScheduleForm.valid) {
      const formValue = this.blockScheduleForm.value;
      const updatedBlockSchedule: BlockScheduleModel = {
        ...formValue,
        updatedAt: new Date(),
        // Add any additional processing here
      };

      console.log('Saving block schedule:', updatedBlockSchedule);

      // Simulate API call
      this.projectService.updateBlockSchedule(updatedBlockSchedule).subscribe(() => {
        console.log('Block schedule updated successfully');
        this.ref.close(updatedBlockSchedule);
      });
    } else {
      // Mark all fields as touched to show validation errors
      Object.keys(this.blockScheduleForm.controls).forEach(key => {
        this.blockScheduleForm.get(key)?.markAsTouched();
      });
    }
  }

  onCancel(): void {
    this.ref.close();
  }

  private handleLoadingError(message: string) {
    console.log(message);
    // You can add toast notifications or other error handling here
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  exportBlockSchedule() {
    this.projectService.downloadBlockSchedule(this.projectId).subscribe(async (event) => {
      if (event != null) {
        const fileName = buildProjectDownloadFileName(this.projectInfo, 'BlockSchedule', 'xlsx');
        this.downloadResponseFile(event, fileName);
      }

    });
  }

  downloadQrLabel(block: BlockScheduleViewModel, event?: Event): void {
    event?.stopPropagation();
    this.projectService.downloadBlockScheduleQrLabel(block.blockScheduleId).subscribe((blob) => {
      if (blob != null) {
        const fileName = buildProjectDownloadFileName(this.projectInfo, 'QR', 'pdf', [
          this.getCustomerMvpsDisplay(block),
        ]);
        this.downloadBlobFile(blob, fileName);
      }
    });
  }

  downloadAllQrLabels(event?: Event): void {
    event?.stopPropagation();
    this.projectService.downloadAllBlockScheduleQrLabels(this.projectId).subscribe((blob) => {
      if (blob != null) {
        const fileName = buildProjectDownloadFileName(this.projectInfo, 'QR', 'pdf', ['AllMVPS']);
        this.downloadBlobFile(blob, fileName);
      }
    });
  }

  private downloadBlobFile(blob: Blob, fileName: string): void {
    if (!blob || blob.size === 0) {
      return;
    }

    const anchor = document.createElement('a');
    const url = URL.createObjectURL(blob);
    anchor.setAttribute('style', 'display:none;');
    document.body.appendChild(anchor);
    anchor.download = fileName;
    anchor.href = url;
    anchor.click();
    document.body.removeChild(anchor);
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  }

  private downloadResponseFile(event: any, fileName: string): void {
    if (!event || event.type !== 4 || !event.body) {
      return;
    }

    this.downloadBlobFile(event.body as Blob, fileName);
  }

  openBulkUpdateDialog() {
    this.dialogRef = this.dialogService.open(Blockschedulebulkupdate, {
      header: 'Block Schedule Bulk Update',
      width: '50rem',     
      maximizable: true,
      modal: true,
      closable: true,
      styleClass: 'kansei-dialog',
      contentStyle: {
        overflow: 'auto'
      },
      data: {
        projectId: this.projectId,
        blockScheduleList: this.blockScheduleList
      }
    });
    this.dialogRef?.onClose.subscribe({
      next: (result) => {
        if (result) {
          console.log('Bulk update completed:', result);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bulk update completed successfully' });
          this.loadBlockSchedule();
        }
      }
    });
  }


  openTemplateConfig(): void {
    console.log('Opening Template Config for project:', this.projectId);

    // Open skidtemplateconfig in modal dialog
    this.dialogRef = this.dialogService.open(SkidtemplateconfigComponent, {
      header: 'MV Power Station Template Configuration',
      width: '70rem',    
      maximizable: true,
      styleClass: 'kansei-dialog',
      modal: true,
      closable: true,
      contentStyle: {
        overflow: 'auto'
      },
      data: {
        projectId: this.projectId
      }
    });

    this.dialogRef?.onClose.subscribe({
      next: (result) => {
        if (result) {
          console.log('Template Config updated:', result);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template configuration updated successfully' });
          this.loadBlockSchedule();
        }
      }
    });
  }

  openSkidSpec(): void {
    console.log('Opening Skid Spec for project:', this.projectId);

    // Check if user can save (you may need to get roleId from user service)
    // For now, we'll pass the projectInfo
    this.dialogRef = this.dialogService.open(SkidspecComponent, {
      header: 'MV Power Station Specification',
      width: '90vw',     
      maximizable: true,
      modal: true,
      styleClass: 'kansei-dialog',
      closable: true,
      contentStyle: {
        overflow: 'hidden',
        padding: '0',
        display: 'flex',
        flexDirection: 'column'
      },
      data: {
        projectInfo: this.projectInfo,
        canSave: this.canSave && !this.isProjectInactive
      }
    });

    this.dialogRef?.onClose.subscribe({
      next: (result) => {
        if (result) {
          console.log('Skid Spec closed:', result);
        }
      }
    });
  }


  openChangeShipDateDialog(): void {
    console.log('Opening Change Ship Date dialog for selected rows:', this.selectedRows);

    // First, fetch transit days from template config
    this.projectService.getBlockScheduleTemplate(this.projectId).subscribe({
      next: (template) => {
        const transitDays = template?.transitDays || 0;

        // Open Change Ship Date dialog
        this.dialogRef = this.dialogService.open(ChangeshipdateComponent, {
          header: `Selected MVPS(s) ${this.selectedRows.length}`,
          width: '30rem',
          modal: true,
          closable: true,
          styleClass: 'kansei-dialog',
          contentStyle: { overflow: 'hidden', padding: '0' },
          data: {
            selectedRows: this.selectedRows,
            transitDays: transitDays
          }
        });

        this.dialogRef?.onClose.subscribe({
          next: (result) => {
            if (result) {
              console.log('Change Ship Date result:', result);
              this.applyShipDateChanges(result.newShipDate, result.newArrivalDate);
            }
          }
        });
      },
      error: (error) => {
        console.error('Error fetching template:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load transit days from template configuration'
        });
      }
    });
  }

  private applyShipDateChanges(newShipDate: Date, newArrivalDate: Date): void {
    // Update ship date and arrival date for all selected rows in memory only
    this.selectedRows.forEach(row => {
      row.shipDate = newShipDate;
      row.arrivalDate = newArrivalDate;

      // Update weekend flags
      row._isShipWeekend = this.checkIsWeekend(newShipDate);
      row._isArrivalWeekend = this.checkIsWeekend(newArrivalDate);
    });

    console.log('Ship date changes applied to selected rows (in-memory only):', this.selectedRows.length);

    // Trigger change detection to update the view
    this.cdr.markForCheck();

    // Note: Changes will be persisted to database when user clicks Save button
  }

  onSelectAllChange(event: any): void {
    this.blockScheduleList.forEach(block => {
      block.selected = this.selectAll;
    });
    this.updateSelectedRows();
    this.initializeActionsMenu();
    this.cdr.markForCheck();
  }

  onRowSelectionChange(): void {
    this.updateSelectedRows();
    this.selectAll = this.blockScheduleList.every(block => block.selected);
    this.initializeActionsMenu();
    this.cdr.markForCheck();
  }

  private updateSelectedRows(): void {
    this.selectedRows = this.blockScheduleList.filter(block => block.selected);
  }

  sendEmail() {
    this.userService.getProjectUserList(this.projectId).subscribe(res => {
      if (res) {
        console.log('Project users for email:', res);
        let emailId = res.map(user => user.email).join(';');
        console.log('Composed email IDs:', emailId);
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        let email: string = `mailto:${emailId}?subject=${this.projectInfo.projectName}-${this.projectInfo.projectNumber} - Block Schedule Update`;
        link.setAttribute('href', email);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    });

  }

  // TrackBy function for performance - helps Angular track row identity
  trackByBlockScheduleId(index: number, block: BlockScheduleViewModel): number {
    return block.blockScheduleId || index;
  }

  // Calculate new skid configuration by counting skid types from block_schedule
  private calculateSkidConfig(): string {
    const counts = { N1: 0, N2: 0, N3: 0, N4: 0, N5: 0, N6: 0, N7: 0 };

    this.blockScheduleList.forEach(block => {
      const config = block.skidConfiguration?.toUpperCase();
      if (config && counts.hasOwnProperty(config)) {
        counts[config as keyof typeof counts]++;
      }
    });

    return `${counts.N1}-${counts.N2}-${counts.N3}-${counts.N4}-${counts.N5}-${counts.N6}-${counts.N7}`;
  }

  // Handle Skid Status change - update computed property
  onSkidStatusChange(block: BlockScheduleViewModel): void {
    if (!this.isCompletedLikeStatus(block.skidStatus)) {
      block._isCompleted = false;
      this.cdr.markForCheck();
      return;
    }

    const requiredCount = this.getRequiredInverterCount(block.skidConfiguration);
    const missingSerialIndexes = this.getMissingInverterSerials(block, requiredCount);
    const hasMvTransformerNumber = !!block.mvXfmrSerialNo?.trim();
    const hasLvTransformerNumber = !!block.lvXfmrSerialNo?.trim();

    const validationMessages: string[] = [];

    if (missingSerialIndexes.length > 0) {
      const serialLabel = missingSerialIndexes.map(index => `INV${index}`).join(', ');
      validationMessages.push(`Missing required inverter serial number(s): ${serialLabel}.`);
    }

    if (!hasMvTransformerNumber) {
      validationMessages.push('MV Transformer Number is required.');
    }

    if (!hasLvTransformerNumber) {
      validationMessages.push('LV Transformer Number is required.');
    }

    if (validationMessages.length > 0) {
      const actualStatus = this.normalizeSkidStatusValue(block._actualSkidStatus);

      this.messageService.add({
        severity: 'warn',
        summary: 'Edit',
        detail: validationMessages.join(' ')
      });

      // Defer rollback so dropdown value cannot be re-applied by the same change cycle.
      setTimeout(() => {
        block.skidStatus = actualStatus;
        block._isCompleted = this.isCompletedLikeStatus(block.skidStatus);
        this.cdr.markForCheck();
      }, 0);
      return;
    }

    block._isCompleted = true;
    this.cdr.markForCheck();
  }

  // Handle Skid Configuration change - update inverter enabled states
  onSkidConfigurationChange(block: BlockScheduleViewModel): void {
    const configNum = block.skidConfiguration ? parseInt(block.skidConfiguration.substring(1)) : 0;
    block._inv1Enabled = configNum >= 1;
    block._inv2Enabled = configNum >= 2;
    block._inv3Enabled = configNum >= 3;
    block._inv4Enabled = configNum >= 4;
    block._inv5Enabled = configNum >= 5;
    block._inv6Enabled = configNum >= 6;
    block._inv7Enabled = configNum >= 7;

    // Also recalculate the new skid config display
    this.newSkidConfig = this.calculateSkidConfig();
    this.cdr.markForCheck();
  }

  onSave(): void {
    console.log('=== SAVE CLICKED ===');
    console.log('Total records in grid:', this.blockScheduleList.length);

    // Set saving flag to show loading state
    this.saving = true;
    this.cdr.markForCheck();

    // Validate two-way contract between Skid Status and Shipping Status
    const validShippedStatuses = [ShippingStatus.DELAYED, ShippingStatus.DELIVERED, ShippingStatus.RETURNED];
    const skidShippingErrors: string[] = [];
    this.blockScheduleList.forEach(block => {
      const skidStatus = (block.skidStatus || '').trim();
      const shippingStatus = (block.shippingStatus || '').trim();
      console.log(`Skid #${block.tmeicSkidNo} — skidStatus: "${skidStatus}" | shippingStatus: "${shippingStatus}"`);

      if (skidStatus === BlockScheduleStatus.SHIPPED) {
        if (!validShippedStatuses.includes(shippingStatus as ShippingStatus)) {
          skidShippingErrors.push(`MV Power Station # ${block.tmeicSkidNo}: Shipping Status must be Delayed, Delivered, or Returned when MV Power Station Status is Shipped.`);
        }
      }

      if (shippingStatus !== '' && skidStatus !== BlockScheduleStatus.SHIPPED) {
        skidShippingErrors.push(`MV Power Station # ${block.tmeicSkidNo}: MV Power Station Status must be Shipped when a Shipping Status is selected.`);
      }
    });

    if (skidShippingErrors.length > 0) {
      this.saving = false;
      this.cdr.markForCheck();
      skidShippingErrors.forEach(msg => {
        this.messageService.add({ severity: 'warn', summary: 'Validation', detail: msg });
      });
      return;
    }

    // Validate shipping status rules before saving
    const shippingValidationErrors: string[] = [];
    this.blockScheduleList.forEach(block => {
      const status = (block.shippingStatus || '').trim();
      const messages: string[] = [];

      if (status !== '') {
        if (!block.billoflading?.trim()) {
          messages.push('Bill of Lading is required.');
        }
        if (!block.appointmentTime) {
          messages.push('Appointment Time is required.');
        }
      }

      if (status === ShippingStatus.DELIVERED) {
        if (!block.deliveryDate) {
          messages.push('Delivery Date is required.');
        }
      }

      if (status === ShippingStatus.RETURNED) {
        if (!block.logisticsComment?.trim()) {
          messages.push('Logistics Comment is required.');
        }
      }

      if (messages.length > 0) {
        shippingValidationErrors.push(`MV Power Station # ${block.tmeicSkidNo}: ${messages.join(' ')}`);
      }
    });

    if (shippingValidationErrors.length > 0) {
      this.saving = false;
      this.cdr.markForCheck();
      shippingValidationErrors.forEach(msg => {
        this.messageService.add({ severity: 'warn', summary: 'Validation', detail: msg });
      });
      return;
    }

    const changedBlocks = this.blockScheduleList.filter(block => this.hasBlockScheduleChanged(block));
    if (changedBlocks.length === 0) {
      this.saving = false;
      this.cdr.markForCheck();
      this.messageService.add({
        severity: 'info',
        summary: 'No Changes',
        detail: 'There are no block schedule changes to save.'
      });
      return;
    }

    // Prepare only changed rows. Preserve original date values unless that exact date field changed.
    const dataToSave = changedBlocks.map(block => this.prepareBlockScheduleForSave(block));

    console.log('Data prepared for save:', dataToSave);

    // Use batch update endpoint, but only for changed records.
    this.projectService.updateBlockScheduleBatch(dataToSave).subscribe({
      next: (response) => {
        this.saving = false;
        this.cdr.markForCheck();

        console.log('Save response:', response);

        if (response && response.length > 0) {
          // Backend returned validation errors — data was NOT saved
          response.forEach(msg => {
            this.messageService.add({
              severity: 'warn',
              summary: 'Save Warning',
              detail: msg
            });
          });
        } else {
          changedBlocks.forEach(block => {
            block._actualSkidStatus = this.normalizeSkidStatusValue(block.skidStatus);
          });
          this.updateOriginalBlockScheduleRowsAfterSave(dataToSave);

          // Show success message
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Block schedule saved successfully. ${changedBlocks.length} record(s) updated.`
          });
        }
      },
      error: (error) => {
        this.saving = false;
        this.cdr.markForCheck();

        console.error('Error saving block schedule:', error);

        // Show error message
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save block schedule data'
        });
      }
    });
  }

  private captureOriginalBlockScheduleRows(rows: BlockScheduleModel[]): void {
    this.originalBlockScheduleRows.clear();
    rows.forEach(row => {
      if (row?.blockScheduleId) {
        this.originalBlockScheduleRows.set(row.blockScheduleId, { ...row });
      }
    });
  }

  private updateOriginalBlockScheduleRowsAfterSave(savedRows: any[]): void {
    savedRows.forEach(row => {
      if (row?.blockScheduleId) {
        this.originalBlockScheduleRows.set(row.blockScheduleId, { ...row });
      }
    });
  }

  private hasBlockScheduleChanged(block: BlockScheduleViewModel): boolean {
    const original = this.originalBlockScheduleRows.get(block.blockScheduleId);
    if (!original) {
      return true;
    }

    return JSON.stringify(this.toComparableBlockSchedule(block)) !== JSON.stringify(this.toComparableBlockSchedule(original));
  }

  private prepareBlockScheduleForSave(block: BlockScheduleViewModel): any {
    const original = this.originalBlockScheduleRows.get(block.blockScheduleId);
    const blockToSave: any = { ...block };

    this.stripViewOnlyProperties(blockToSave);

    this.applyDateForSave(blockToSave, original, 'shipDate');
    this.applyDateForSave(blockToSave, original, 'arrivalDate');
    this.applyDateForSave(blockToSave, original, 'deliveryDate');
    this.applyDateForSave(blockToSave, original, 'estimatedDeliveryDate');
    this.applyAppointmentTimeForSave(blockToSave, original);

    return blockToSave;
  }

  private applyDateForSave(target: any, original: any, key: keyof BlockScheduleModel): void {
    if (original && !this.hasDateValueChanged(target[key], original[key])) {
      target[key] = original[key] ?? null;
      return;
    }

    target[key] = this.serializeDateTimeForApi(target[key]);
  }

  private applyAppointmentTimeForSave(target: any, original: any): void {
    if (original && !this.hasDateValueChanged(target.appointmentTime, original.appointmentTime)) {
      target.appointmentTime = original.appointmentTime ?? null;
      return;
    }

    if (target.appointmentTime instanceof Date) {
      const date = target.appointmentTime;
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      target.appointmentTime = `1900-01-01T${hours}:${minutes}:${seconds}`;
      return;
    }

    target.appointmentTime = target.appointmentTime ?? null;
  }

  private serializeDateTimeForApi(value: unknown): string | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value.toISOString();
    }

    return String(value);
  }

  private hasDateValueChanged(current: unknown, original: unknown): boolean {
    return this.toDateCompareValue(current) !== this.toDateCompareValue(original);
  }

  private toDateCompareValue(value: unknown): string {
    if (!value) {
      return '';
    }

    const date = value instanceof Date ? value : new Date(String(value));
    if (!Number.isNaN(date.getTime())) {
      return String(date.getTime());
    }

    return String(value).trim();
  }

  private toComparableBlockSchedule(row: BlockScheduleModel): any {
    const comparable: any = { ...row };
    this.stripViewOnlyProperties(comparable);

    ['shipDate', 'arrivalDate', 'deliveryDate', 'estimatedDeliveryDate', 'appointmentTime', 'createdDate', 'updatedDate']
      .forEach(key => {
        comparable[key] = this.toDateCompareValue(comparable[key]);
      });

    Object.keys(comparable).forEach(key => {
      if (typeof comparable[key] === 'string') {
        comparable[key] = comparable[key].trim();
      }
    });

    return comparable;
  }

  private stripViewOnlyProperties(row: any): void {
    [
      'selected',
      '_isCompleted',
      '_actualSkidStatus',
      '_inv1Enabled',
      '_inv2Enabled',
      '_inv3Enabled',
      '_inv4Enabled',
      '_inv5Enabled',
      '_inv6Enabled',
      '_inv7Enabled',
      '_isShipWeekend',
      '_isArrivalWeekend'
    ].forEach(key => delete row[key]);
  }

  // Handle ship date icon click - open confirmation dialog
  onDeliveryDateClick(block: BlockScheduleViewModel, event: Event, panel: Popover): void {
    this.activeDeliveryBlock = block;
    panel.show(event);
  }

  onDeliveryDateSelect(date: Date, panel: Popover): void {
    if (this.activeDeliveryBlock) {
      this.activeDeliveryBlock.deliveryDate = date;
      this.cdr.markForCheck();
    }
    panel.hide();
  }

  onEstimatedDeliveryDateClick(block: BlockScheduleViewModel, event: Event, panel: Popover): void {
    this.activeEstimatedDeliveryBlock = block;
    panel.show(event);
  }

  onEstimatedDeliveryDateSelect(date: Date, panel: Popover): void {
    if (this.activeEstimatedDeliveryBlock) {
      this.activeEstimatedDeliveryBlock.estimatedDeliveryDate = date;
      this.cdr.markForCheck();
    }
    panel.hide();
  }

  onShipDateIconClick(block: BlockScheduleViewModel, event: Event, panel: Popover): void {
    this.activeShipBlock = block;
    this.projectService.getBlockScheduleTemplate(this.projectId).subscribe({
      next: (template) => { this.shipTransitDays = template?.transitDays || 0; },
      error: () => { this.shipTransitDays = 0; }
    });
    panel.show(event);
  }

  onShipDateSelect(date: Date, panel: Popover): void {
    if (this.activeShipBlock) {
      this.activeShipBlock.shipDate = new Date(date);
      this.activeShipBlock._isShipWeekend = this.checkIsWeekend(date);
      const arrivalDate = new Date(date);
      arrivalDate.setDate(arrivalDate.getDate() + this.shipTransitDays);
      this.activeShipBlock.arrivalDate = arrivalDate;
      this.activeShipBlock._isArrivalWeekend = this.checkIsWeekend(arrivalDate);
      this.cdr.markForCheck();
    }
    panel.hide();
  }

  onArrivalDateIconClick(block: BlockScheduleViewModel, event: Event, panel: Popover): void {
    this.activeArrivalBlock = block;
    panel.show(event);
  }

  onArrivalDateSelect(date: Date, panel: Popover): void {
    if (this.activeArrivalBlock) {
      this.activeArrivalBlock.arrivalDate = date;
      this.activeArrivalBlock._isArrivalWeekend = this.checkIsWeekend(date);
      this.cdr.markForCheck();
    }
    panel.hide();
  }

  /**
   * Role-based permission helper methods
   * These methods bridge the PermissionService with the template
   * They are optimized to prevent change detection loops
   */

  /**
   * Check if skid configuration should be disabled
   * Special logic: Admin can edit unless status is Complete/In-Progress
   */
  isSkidConfigDisabled(block: BlockScheduleModel): boolean {
    return this.isReadOnly || this.permissions.isSkidConfigDisabled(block.skidStatus);
  }

  /**
   * Check if inverter field should be disabled
   * Special logic: Enabled based on N-configuration
   */
  isInverterFieldDisabled(block: BlockScheduleModel, inverterNum: number): boolean {
    return this.permissions.isInverterFieldDisabled(inverterNum, block.skidConfiguration);
  }

}
